import { takeLatest, put, call, all } from "redux-saga/effects";

import { GET_BUSINESS_OVERVIEW_DATA } from "./actionType";

import {
  getBusinessOverviewDataSuccess,
  getBusinessOverviewDataError,
} from "./action";

import { getBusinessOverviewDataApiCall } from "../../helpers/fakebackend_helper";

// Get Business Overview dashboard data
export function* getBusinessOverviewDataItems({ payload }) {
  try {
    const response = yield call(getBusinessOverviewDataApiCall, payload);
    yield put(getBusinessOverviewDataSuccess(response));
  } catch (error) {
    yield put(getBusinessOverviewDataError(error));
  }
}

export function* watchGetBusinessOverviewData() {
  yield takeLatest(GET_BUSINESS_OVERVIEW_DATA, getBusinessOverviewDataItems);
}

// Business Overview Root Saga
function* BusinessOverview() {
  yield all([call(watchGetBusinessOverviewData)]);
}

export default BusinessOverview;
